export interface ApiError {
  status: number;
  message: string;
  fields?: Record<string, string[]>;
}

export async function api<T>(
  path: string,
  options: RequestInit & { json?: unknown } = {},
): Promise<T> {
  const { json, headers, ...rest } = options;
  const init: RequestInit = {
    credentials: "include",
    headers: {
      Accept: "application/json",
      ...(json !== undefined ? { "Content-Type": "application/json" } : {}),
      ...headers,
    },
    body: json !== undefined ? JSON.stringify(json) : (rest.body as BodyInit | undefined),
    ...rest,
  };

  const res = await fetch(path.startsWith("/") ? path : `/${path}`, init);

  if (res.status === 204) return undefined as unknown as T;

  const text = await res.text();
  const body: unknown = text ? safeParse(text) : null;

  if (!res.ok) {
    const err: ApiError = {
      status: res.status,
      message: (body as { error?: string })?.error ?? `request failed (${res.status})`,
      fields: (body as { fields?: Record<string, string[]> })?.fields,
    };
    throw err;
  }
  return body as T;
}

function safeParse(s: string): unknown {
  try {
    return JSON.parse(s);
  } catch {
    return s;
  }
}
